// extracted by mini-css-extract-plugin
module.exports = {"article-main":"ArticleMain_article-main__1RUR_","article-main__wrapper":"ArticleMain_article-main__wrapper__qyS0j"};